import angular from 'angular';
import template from './resetMobilePassword.html';

class ResetMobilePasswordController {
    constructor($uibModal, DataApiService) {
        'ngInject';
        this.$uibModal = $uibModal;
        this.DataApiService = DataApiService;
    }

    $onInit() {
        this.token = this.token || '';
        this.from = this.from || '';
        this.resetSuccess = false;
    }

    handleSubmitPassword(event) {
        let password = event.password;
        this.DataApiService.rpcResetPassword(this.from, this.token, password)
            .then(() => {
                this.resetSuccess = true;
            })
            .catch((error) => {
                alert(error);
            });
    }

    handleResendPwLink() {
        let modal = this.$uibModal.open({
            backdropClass: 'mms-backdrop',
            component: 'mmsForgotPasswordModal',
            windowClass: 'modal-pw'
        });
        modal.result
            .then(() => {
                this.hasResendPwLink = true;
            })
            .catch(() => {
                this.hasResendPwLink = false;
            });
    }

}

export const ResetMobilePasswordComponent = {
    name: 'mmsResetMobilePassword',
    component: {
        template,
        controller: ResetMobilePasswordController,
        bindings: {
            token: '<',
            from: '<',
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/pages/resetMobilePw/resetMobilePassword.component.js